module.exports = __webpack_public_path__ + "static/media/grin-tongue-wink.bf5f3e9e.svg";